module.exports = __webpack_public_path__ + "static/media/3364-e-l-en.b550af41.png";